import React,{useState,useEffect} from 'react'
import Grid from '@mui/material/Grid';
import { TextAreaInput1, TextInput } from '../../components/input';
import { ButtonFilled, ButtonOutlined } from '../../components/button';
import { useLocation, useNavigate } from 'react-router-dom';
import GoBack from '../../components/back/GoBack';
import Uploader from '../../components/Uploader';
import { FilterClientService } from '../../services/ClientService';
import toast from 'react-hot-toast';
import {  GetCaseDetailService } from '../../services/CaseService';
import { Select } from 'antd';
import OpinionMenu from './OpinionMenu';
import { CreateOpinionFileService, GetOpinionFileDetailService, UpdateOpinionFileService, UploadOpinionFileFile } from '../../services/OpinionFileService';
import { GetSearchService } from '../../services/AuthServices';
import { CreateActivityService } from '../../services/ActivityServices';
// import DailyTaskCE from './dailyTask/DailyTaskCE';

function OpinionCE() {

 
  const [loader,setloader] = useState(false)  
  const [clientArr,setclientArr] = useState([])
  const [userArr,setuserArr] = useState([])
  const {state,pathname} = useLocation()


  const path = pathname?.split('/')[pathname?.split('/').length -1]
  const path1 = pathname?.split('/')[pathname?.split('/').length -2]

  const status = [
    {label:'Pending',value:'Pending'},
    {label:'In Progress',value:'In Progress'},
    {label:'Completed',value:'Completed'},
    {label:'Hold',value:'Hold'},
  ]

  const [data,setdata] = useState({
    office_file_no:'',
    client:'',
    property_details:'',
    advocate_for:'',
    work_details:'',
    allocation_of_work:'',
    comments:'',
    file:''
  })

  const [error,seterror] = useState({
    office_file_no:'',
    client:'',
    property_details:'',
    advocate_for:'',
    work_details:'',
    allocation_of_work:'',
    comments:'',
    file:''
  })

  const [activity,setactivity] = useState({attachment:'',remarks:'',next_hearing_date:''})
  const [activityerror,setactivityerror] = useState({attachment:'',remarks:'',next_hearing_date:''})

  const navigate = useNavigate()


  useEffect(()=>{
    if(path === 'edit'){
      geteditdata()
    }
  },[])

  async function geteditdata(){
    const response =  await GetOpinionFileDetailService(state?._id);
    let d = response?.data?.datas[0]
    if(d?._id !== undefined){

      let sendData = {...d}
      delete d.created_by

    

      if(d?.client?._id !== undefined){
        sendData['client'] = {label:d?.client?.name,value:d?.client?._id,data:d?.client}
      }

      if(d?.allocation_of_work?._id !== undefined){
        sendData['allocation_of_work'] = {label:d?.allocation_of_work?.name,value:d?.allocation_of_work?._id,data:d?.allocation_of_work}
      }

      if(d?.status !== undefined && d?.status !== null && d?.status !== ''){
        sendData['status'] = {label:d?.status,value:d?.status}
      }

      setdata({...sendData})
    }
  }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name] : ''})
  }

  function handlechange1(e){
    setactivity({...activity,[e.target.name] : e.target.value})
    setactivityerror({...activityerror,[e.target.name] : ''})
  }

  async function submitform(){
    const sendData = {...data}

    if(data?.client?.value !== undefined){
      sendData['client'] = data?.client?.value
    }

    if(data?.allocation_of_work?.value !== undefined){
      sendData['allocation_of_work'] = data?.allocation_of_work?.value
    }
  
    if(data?.status?.value !== undefined){
      sendData['status'] = data?.status?.value
    }

    if(path !== 'edit'){
      const response = await CreateOpinionFileService(sendData)
      if(response?.status === 201){
          toast.success("Opinion File Added Successfully!")
          resetform()
      }else{
          console.log("reponse?.data",response?.data)
      }
    }else{
      const response = await UpdateOpinionFileService(sendData,state?._id)
      if(response?.status === 200){
          await createactivity()
          toast.success("Opinion File Updated Successfully!")
          navigate(-1)
          resetform()
      }else{
          console.log("reponse?.data",response?.data)
      }
    }
    
  }

  function resetform(){
     setdata({
        office_file_no:'',
        client:'',
        property_details:'',
        work_details:'',
        allocation_of_work:'',
        comments:'',
        file:''
      })
      seterror({
        office_file_no:'',
        client:'',
        property_details:'',
        work_details:'',
        allocation_of_work:'',
        comments:'',
        file:''
      })
  }

  async function UploadFile(e,name){
    const response = await UploadOpinionFileFile({file:e})
    setdata({...data,[name]:response?.data?.data})
  }

  async function UploadFile1(e,name){
    const response = await UploadOpinionFileFile({file:e})
    setactivity({...activity,[name]:response?.data?.data})
  }


  async function searchData(e,type){
  
  
   if(type == 'client'){
    const response = await FilterClientService(1,e,'','','active')
    let datas = response?.data?.datas
    if(datas?.length > 0){
      let arr = []
      datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id,data:d})
      })
      setclientArr(arr)
    }
   }

   if(type == 'allocation_of_work'){
    const response = await GetSearchService(e,1)
    let datas = response?.data?.datas
    if(datas?.length > 0){
      let arr = []
      datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id,data:d})
      })
      setuserArr(arr)
    }
   }
  }

  async function handleselect(e,type){
    if(type == 'client'){
      let dataFind = clientArr.find((f)=>f?.value === e)
      setdata({...data,[type]:dataFind})
    }
    if(type == 'status'){
      let dataFind = status.find((f)=>f?.value === e)
      setdata({...data,[type]:dataFind})
    }
    if(type == 'allocation_of_work'){
      let dataFind = userArr.find((f)=>f?.value === e)
      setdata({...data,[type]:dataFind})
    }
  }

  async function createactivity(){
    const send_data = {
      // case:data?._id, 
      opinion_file:data?._id, 
      client:data?.client?.value, 
      stage:data?.stage?.value, 
      attachment:activity?.attachment, 
      remarks:activity?.remarks, 
      next_hearing_date:'', 
      type:'opinion_file', 
    }

    if(activity?.next_hearing_date !== ''){
      send_data['next_hearing_date'] = activity?.next_hearing_date
    }

    const response = await CreateActivityService(send_data)
    if(response?.status === 201){
      toast.success("Activity Created Successfully")
    }
  }


  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
    <div className='block sm:flex'>
        <OpinionMenu />
    <div className='pr-5 ml-5 md:min-h-screen md:max-h-screen md:h-screen md:overflow-y-scroll' >
    

  

    <div className='md:w-[85%] md:min-w-[20vw] md:max-w-[20vw] mt-4 '>
      <GoBack />
     <div className='border-b  pb-2'>
      <h6 className='font-[800] mb-1'>{path === 'edit' ? 'Edit' : 'Create'} Opinion File Info</h6> 
      <h6 className='text-[11px] leading-tight font-[500] p-2 bg-slate-100 '>Use the below form to create or edit the Opinion file information for your client .</h6> 
     </div> 
     <div className='w-[100%] md:overflow-x-hidden'>

      {/* <h6 className='font-[800] text-[11px] bg-slate-100 p-[4px] mt-2'>Basic Info</h6>   */}
      <Grid container spacing={2}  >
        <Grid item xs={12}  md={12} >

      
        <h6 className='text-[11px] mt-2 font-[400] mb-1' >Client</h6>
        <Select 
          value={data.client}
          allowClear={true}
          showSearch={true}
          filterOption={false}
          onSearch={(e)=>searchData(e,'client')}
          onChange={e=>{handleselect(e,'client')}}
          options={clientArr}
          bordered={false}
          className='w-[100%] border border-slate-300'
        />



          <TextInput 
              mandatory={true}
              label={'Office File No'}  
              variant="standard"
              name="office_file_no"
              type="text"
              value={data.office_file_no}
              error={error.office_file_no}
              handlechange={handlechange}
              placeholder="Enter client name"
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>
              

          <TextAreaInput1 
            label={'Property Details'}  
            variant="standard"
            name="property_details"
            type="text"
            value={data.property_details}
            error={error.property_details}
            handlechange={handlechange}
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

          <TextAreaInput1 
            label={'Work Details'}  
            variant="standard"
            name="work_details"
            type="text"
            value={data.work_details}
            error={error.work_details}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>


<h6 className='text-[11px] mt-2 font-[400] mb-1' >Allocation Of Work</h6>
        <Select 
          value={data.allocation_of_work}
          allowClear={true}
          showSearch={true}
          filterOption={false}
          onSearch={(e)=>searchData(e,'allocation_of_work')}
          onChange={e=>{handleselect(e,'allocation_of_work')}}
          options={userArr}
          bordered={false}
          className='w-[100%] border border-slate-300'
        />

         <div className='mt-0' >
         
         <Uploader error={error?.file} name="file" required={true} label={'File'} image={data?.file}  setimagefunc={(e)=>{UploadFile(e,'file');seterror({...error,file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,file:''});seterror({...error,file:''})}} />



              <TextAreaInput1 
            label={'Comments'}  
            variant="standard"
            name="comments"
            type="text"
            value={data.comments}
            error={error.comments}
            handlechange={handlechange}
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

      

<h6 className='text-[11px] mt-2 font-[400] mb-1' >Status</h6>
        <Select 
          value={data.status}
          // allowClear={true}
          // showSearch={true}
          // filterOption={false}
          // onSearch={(e)=>searchData(e,'stage')}
          onChange={e=>{handleselect(e,'status')}}
          options={status}
          bordered={false}
          className='w-[100%] border border-slate-300'
        />


{(state?._id !== undefined) &&
        <div>
          <Uploader error={activityerror?.attachment} name="attachment" required={false} label={'Attachment'} image={activity?.attachment}  setimagefunc={(e)=>{UploadFile1(e,'attachment');setactivityerror({...activityerror,attachment:''})}}  removeimageuploadfunc = {()=>{setactivity({...activity,attachment:''});setactivityerror({...activityerror,attachment:''})}} />
        
          <TextAreaInput1 
              label={'Remarks'}  
              variant="standard"
              name="remarks"
              type="text"
              value={activity.remarks}
              error={activityerror.remarks}
              handlechange={handlechange1}
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>

          <TextInput 
              mandatory={false}
              label={'Next Hearing Date'}  
              variant="standard"
              name="next_hearing_date"
              type="date"
              value={activity.next_hearing_date}
              error={activityerror.next_hearing_date}
              handlechange={handlechange1}
              placeholder="Enter contact mobile"
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>
        </div> }
        
        


         </div>

         

            
        </Grid>
        <Grid item xs={12} md={6} >
        
         


       

        
       
        </Grid>
      </Grid>

   
      </div>

   
   <div >
    <div className='flex items-center mt-5 mb-10  border-t pt-5'>
        <div className='mr-2'>
        <ButtonOutlined btnName={'Back'} onClick={()=>navigate(-1)} />
        </div>
        <div>
        {loader ?   
        <ButtonFilled btnName={loader ? 'Loading' : 'Save'} /> :
        <ButtonFilled btnName={loader ? 'Loading' : 'Save'} onClick={()=>submitform(null)} /> }
        </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
   
  )
}

export default OpinionCE